import { createProfessionalExporter } from '../../utils/professionalExport';

const headers = ['Serial No', 'Member', 'Freeze Start', 'Freeze End', 'Reason', 'Auto Extend', 'Status'];

function gymIdForRow(a) {
  return a.gymId || '—';
}

const exporter = createProfessionalExporter({
  title: 'Freeze Accounts',
  headers,
  slug: 'freeze-accounts',
  getRows: (list) =>
    list.map((a) => [
      gymIdForRow(a),
      a.member,
      a.startDate,
      a.endDate,
      a.reason,
      a.autoExtend ? 'Yes' : 'No',
      a.status === 'active' ? 'Active' : 'Completed',
    ]),
  getSummary: (list) => [`Total freeze records: ${list.length}`],
});

export const printFreezeList = (data) => exporter.print(data);
export const exportFreezeCsv = (data) => exporter.csv(data);
export const exportFreezeExcel = (data) => exporter.excel(data);
export const exportFreezePdf = (data) => exporter.pdf(data);
export const exportFreezeAccounts = (data) => exporter.export(data);
